module.exports = ".no-vertical-padding {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main